import styled, { css } from 'styled-components';

const cardBase = css`
	border-radius: 4px;
	padding: 12px;

	// Anchors the absolutely placed status label.
	overflow: hidden;
	position: relative;
`;

const contestSurface = css`
	background-color: ${props => props.theme.surface[2]};
	box-shadow: ${props => props.theme.shadow.inset};
`;

export const ContestPerformanceCardWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;

	${cardBase}
	${contestSurface}
`;

export const ContestPerformanceCardHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;

	// Leaves room for the absolutely placed status label without guessing at it.
	padding-right: 120px;
`;

export const ScheduledLabelWrapper = styled.div`
	position: absolute;
	top: 12px;
	right: 12px;
	z-index: 2;
`;

export const ContestPerformanceCardTitle = styled.h3`
	font-size: 16px;
	font-weight: 600;
	color: ${props => props.theme.text.primary};
	font-family: ${props => props.theme.font};
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	max-width: 100%;
	margin: 0;
`;

export const ContestPerformanceCardDate = styled.p`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	color: ${props => props.theme.text.tertiary};
	font-family: ${props => props.theme.font};
	margin: 0;
`;

export const ContestPerformanceCardName = styled.h4`
	font-size: 16px;
	color: ${props => props.theme.text.primary};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 100%;
	font-family: ${props => props.theme.font};
	margin: 0;
`;

export const ContestPerformanceCardContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
`;

export const ContestPerformanceCardContentWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const ContestPerformanceCardContentValue = styled.p`
	font-size: 16px;
	color: ${props => props.theme.text.primary};
	font-family: ${props => props.theme.font};
	margin: 0;
`;
